import { PROJECT_ROLES } from './projects.const';

const inviteAndCollaborate = async ({
	collaborateNewProjectAction = () => {},
	projectId,
	emailMessage,
	isSendMail,
	groupsSelected,
	inviteUserRole,
	allUsersToCollaborateWith,
	role = PROJECT_ROLES.ADMIN,
}) => {
	if (allUsersToCollaborateWith.length > 0 || groupsSelected.length > 0) {
		const res = await collaborateNewProjectAction({
			projectId,
			users: allUsersToCollaborateWith,
			groups: groupsSelected,
			role,
			emailMessage,
			isSendMail,
			inviteUserRole,
		});
		return res;
	} else {
		console.log('no emails to collaborate with');
		return null;
	}
};

const CollaborateProjectsService = {
	inviteAndCollaborate,
};

export default CollaborateProjectsService;
